import React from 'react';
import { ArrowRightIcon, BookOpenIcon, BriefcaseIcon, BuildingIcon, ScaleIcon, DatabaseIcon } from 'lucide-react';
const defaultFeatures = [{
  title: 'Using the Openmart API to fetch data',
  description: 'Integrate the Openmart API into your application.',
  href: 'https://openmart.com/product-tutorials/using-the-openmart-api-to-fetch-data',
  cta: 'Read tutorial',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Clay + Openmart integration',
  description: 'Combine Clay and Openmart to enrich lead lists.',
  href: 'https://openmart.com/product-tutorials/clay-openmart',
  cta: 'View guide',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Billion Dollar Market case study',
  description: 'How a sales team used Openmart to break into a billion-dollar local services market.',
  href: 'https://www.openmart.com/case-study/billion-dollar-market',
  cta: 'Read case study',
  type: 'Case Study',
  color: 'green' as const,
  icon: BriefcaseIcon
}, {
  title: 'Property management contacts database',
  description: 'Find property management companies with verified contact details.',
  href: 'https://www.openmart.com/data/property-management',
  cta: 'Explore data',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Landscaper contacts database',
  description: 'Access landscaping companies with verified details.',
  href: 'https://www.openmart.com/data/landscapers',
  cta: 'Explore landscapers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Openmart vs Apollo',
  description: 'Compare coverage, accuracy, and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-apollo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}];
const colorClasses = {
  blue: 'bg-blue-100 text-blue-700 border-blue-200',
  green: 'bg-green-100 text-green-700 border-green-200',
  purple: 'bg-purple-100 text-purple-700 border-purple-200',
  orange: 'bg-orange-100 text-orange-700 border-orange-200'
};
interface RelatedFeaturesProps {
  features?: typeof defaultFeatures;
}
export function RelatedFeatures({
  features = defaultFeatures
}: RelatedFeaturesProps = {}) {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6273">
      <div className="bg-white rounded-[2.5rem] shadow-sm border border-slate-100 p-8 md:p-12 lg:p-16 relative overflow-hidden" data-id="element-6274">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-10 tracking-tight" data-id="element-6275">
          Explore related resources
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6276">
          {features.map(feature => {
          return <a key={feature.href} href={feature.href} className="group flex flex-col p-6 rounded-2xl bg-white border-2 border-slate-200 hover:border-blue-500 hover:shadow-lg transition-all duration-200" data-id="element-6277">
                <div className="mb-4" data-id="element-6278">
                  <span className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full ${colorClasses[feature.color]}`} data-id="element-6279">
                    <feature.icon className="w-3.5 h-3.5" data-id="element-6280" />
                    {feature.type}
                  </span>
                </div>

                <h3 className="text-lg font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors" data-id="element-6281">
                  {feature.title}
                </h3>
                <p className="text-sm text-slate-600 mb-4 flex-1" data-id="element-6282">
                  {feature.description}
                </p>

                <div className="flex items-center gap-1.5 text-sm font-semibold text-blue-600 group-hover:gap-2.5 transition-all" data-id="element-6283">
                  {feature.cta}
                  <ArrowRightIcon className="w-4 h-4" data-id="element-6284" />
                </div>
              </a>;
        })}
        </div>
      </div>
    </section>;
}